import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Activity, BarChart3, BookMarked, BookOpenCheck, FolderLock, GitBranch, ImageIcon, LogOut, Moon, QrCode, Radio, ScrollText, Settings, Sun, Ticket, UserCog, Video, Wifi } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";

const links = [
  { to: "/admin", label: "Analytics", icon: BarChart3, end: true, perm: "analytics", testid: "admin-nav-dashboard" },
  { to: "/admin/tickets", label: "Tickets", icon: Ticket, perm: "tickets", testid: "admin-nav-tickets" },
  { to: "/admin/arbres", label: "Fiches types", icon: GitBranch, perm: "arbres", testid: "admin-nav-arbres" },
  { to: "/admin/clients", label: "Parc client / QR", icon: QrCode, perm: "clients", testid: "admin-nav-clients" },
  { to: "/admin/documents", label: "Documents", icon: FolderLock, perm: "documents", testid: "admin-nav-documents" },
  { to: "/admin/journal", label: "Journal accès", icon: ScrollText, perm: "documents", testid: "admin-nav-journal" },
  { to: "/admin/tutos", label: "Librairie", icon: Video, perm: "tutos", testid: "admin-nav-tutos" },
  { to: "/admin/notices", label: "Notices IA", icon: BookOpenCheck, perm: "tutos", testid: "admin-nav-notices" },
  { to: "/admin/savoir", label: "Savoir terrain", icon: BookMarked, perm: "tutos", testid: "admin-nav-savoir" },
  { to: "/admin/supervision", label: "Supervision", icon: Activity, perm: "clients", testid: "admin-nav-supervision" },
  { to: "/admin/sondes", label: "Ping appareils", icon: Wifi, perm: "clients", testid: "admin-nav-sondes" },
  { to: "/admin/alertes", label: "Alertes équipements", icon: Radio, perm: "clients", testid: "admin-nav-alertes" },
  { to: "/admin/vitrine", label: "Vitrine", icon: ImageIcon, perm: "vitrine", testid: "admin-nav-vitrine" },
  { to: "/admin/utilisateurs", label: "Utilisateurs", icon: UserCog, perm: "utilisateurs", testid: "admin-nav-utilisateurs" },
  { to: "/admin/reglages", label: "Réglages", icon: Settings, perm: "reglages", testid: "admin-nav-reglages" },
];

export default function AdminShell() {
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const perms = user?.permissions || [];
  const visibles = links.filter((l) => perms.includes(l.perm));

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#0A0A0A] lg:flex">
      <aside className="lg:w-60 lg:min-h-screen bg-[#0A0A0A] text-white/70 lg:sticky lg:top-0 border-r border-white/10">
        <div className="p-5">
          <div className="font-display text-lg font-extrabold tracking-tighter text-white">
            BK<span className="text-[#005CFF]">PROD</span>
          </div>
          <div className="text-[11px] text-white/40">{user?.nom || "Back-office BKPRO"}</div>
        </div>
        <nav className="flex lg:flex-col gap-1 px-3 pb-3 overflow-x-auto">
          {visibles.map(({ to, label, icon: Icon, end, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `shrink-0 flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-[#005CFF] text-white bk-glow" : "hover:bg-white/10 hover:text-white"}`
              }
            >
              <Icon size={16} /> {label}
            </NavLink>
          ))}
          <button
            data-testid="theme-toggle-btn"
            onClick={toggle}
            title={theme === "dark" ? "Basculer en mode clair" : "Basculer en mode sombre"}
            className="shrink-0 flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm hover:bg-white/10 hover:text-white"
          >
            {theme === "dark" ? <Moon size={16} /> : <Sun size={16} />}
            <span data-testid="theme-current-label">Thème : {theme === "dark" ? "sombre" : "clair"}</span>
          </button>
          <button
            data-testid="admin-logout-btn"
            onClick={() => {
              logout();
              navigate("/admin/login");
            }}
            className="shrink-0 flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm hover:bg-white/10 hover:text-white"
          >
            <LogOut size={16} /> Quitter
          </button>
        </nav>
      </aside>
      <main className="flex-1 p-5 lg:p-10 max-w-6xl">
        <Outlet />
      </main>
    </div>
  );
}
